var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticStyle:{"color":"white"},attrs:{"href":"https://www.notion.so/birdeatsbug/Intro-Call-JS-Questions-2d7bdf65268c403e835e2256b2a18be0","target":"_blank","noref":"","nofollow":""}},[_vm._v(" This page has been moved to Notion ")])}
var staticRenderFns = []

export { render, staticRenderFns }